import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#1ed760',
  width = '100%',
  className = '',
  viewBox = '0 0 30 30',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2" transform="translate(12815 -9670)">
        <path
          fill={fill}
          d="M5,0H25a5,5,0,0,1,5,5V25a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
          transform="translate(-12815 9670)"
        />
        <circle
          data-name="Elipse 476"
          cx="14"
          cy="14"
          r="14"
          transform="translate(-12814 9671)"
          fill="#fff"
        />
        <path
          fill={fill}
          d="M14.819,8A14.819,14.819,0,1,0,29.638,22.819,14.824,14.824,0,0,0,14.819,8Zm6.017,21.8a1.14,1.14,0,0,1-.639-.215c-3.729-2.247-8.067-2.342-12.351-1.464a3.858,3.858,0,0,1-.711.155.93.93,0,0,1-.944-.944.947.947,0,0,1,.813-1c4.894-1.082,9.9-.986,14.162,1.566a1.011,1.011,0,0,1,.58.986A.9.9,0,0,1,20.836,29.8Zm1.607-3.92a1.475,1.475,0,0,1-.735-.251A19.364,19.364,0,0,0,7.451,23.876a2.461,2.461,0,0,1-.711.155,1.16,1.16,0,0,1-1.159-1.159,1.176,1.176,0,0,1,.926-1.237,20.1,20.1,0,0,1,5.844-.813,20.917,20.917,0,0,1,10.576,2.719,1.246,1.246,0,0,1,.675,1.177A1.158,1.158,0,0,1,22.443,25.884ZM24.3,21.331a1.374,1.374,0,0,1-.771-.233c-4.254-2.54-11.861-3.149-16.785-1.775a2.838,2.838,0,0,1-.771.155,1.379,1.379,0,0,1-1.392-1.41,1.412,1.412,0,0,1,1.04-1.428,25.043,25.043,0,0,1,7.021-.908,25.237,25.237,0,0,1,12.273,2.856,1.4,1.4,0,0,1,.771,1.35A1.384,1.384,0,0,1,24.3,21.331Z"
          transform="translate(-12815 9662.362)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
